import { h } from "preact";
import "./DragLabel.scss";

export const DragLabel = () => <div id="dragLabel" className="dragLabel kd7" />;
